<h2 mat-dialog-title>DETALLE PINCKING</h2>
<mat-dialog-content class="mat-typography">
  <!-- <div class="contenedor-form" *ngIf="loadingData">
    <mat-spinner
      [diameter]="100"
      style="margin:0 auto; top:15px;"
    ></mat-spinner>
  </div> -->

  <!--
    <mat-expansion-panel [hidden]="loadingData" expanded="false">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h4 class="titulo-solicitud">INFORMACIÓN CLIENTE</h4>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="row" [hidden]="loadingData">
        <div class="col s12 m12 l12">
            <div class="table-wrapper">
                <table class="fl-table">
                    <thead>
                    <tr>
                        <th>Nit</th>
                        <th>Cliente</th>
                        <th>Ciudad</th>
                        <th>Direccion</th>
                        <th>Telefono</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr >
                        <td>{{dataCliente.codigo}}</td>
                        <td>{{dataCliente.cliente}}</td>
                        <td>{{dataCliente.ciudad}}</td>
                        <td>{{dataCliente.direccion}}</td>
                        <td>{{dataCliente.telefono}}</td>
                    </tr>
                    <tbody>
                </table>
            </div>
        </div>
    </div>
  </mat-expansion-panel>
  <br />
  <div class="row">
    <div class="col s12 m12 l12">
      <p><span style="font-weight: bold;" >OBSERVACIONES:</span> {{dataCliente.observaciones}}</p>
    </div>
  </div>
 -->

 <mat-expansion-panel [hidden]="loadingData" expanded="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <h4 class="titulo-solicitud">ASIGNACION DEL TRANSPORTADOR</h4>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div class="contenedor-form">
    <form [formGroup]="asignacionGroup" (ngSubmit)="registrarAsignacion();" class="example-form">
  <div class="row center">

 <div class="col s6 m8 l8">
  <span *ngIf="loadingTransportador">
      <mat-spinner
      [diameter]="30"
      style="margin:0 auto; top:15px;"
    ></mat-spinner>
  </span>
<span *ngIf="!loadingTransportador">
  <mat-form-field class="example-full-width" appearance="outline" >
    <mat-label>Transportador</mat-label>
      <input matInput placeholder="Transportador" [matAutocomplete]="auto" formControlName="cbxTransportador">
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
        <mat-option *ngFor="let item of listaTransportadores | async" [value]="item">
          <span>{{item.valor}}</span>
        </mat-option>
      </mat-autocomplete>
  </mat-form-field>
</span>
</div>

<div class="col s6 m4 l4">
  <button mat-raised-button color="accent" type="submit" [disabled]="!asignacionGroup.valid || loadingTransportador">Asignar</button>
</div>

</div>
</form>
</div>
</mat-expansion-panel>

<br/>
<br/>

  <div class="row" [hidden]="loadingData">
    <div class="col s12 m12 l12">
      <table
        [hidden]="!haveData"
        datatable
        [dtTrigger]="dtTrigger"
        class="display"
        style="width:100%; font-size: 10px;"
      >
        <thead>
          <tr>
            <th>Numero Pedido</th>
            <th>Cod. Producto</th>
            <th>Descripción</th>
            <th>Cant. Pedido</th>
            <th>Cant. Picking</th>
            <th>Fecha Pedido</th>
            <th>Fecha Picking</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of listaDetallePicking; let i = index">
            <td style="text-align: center;">
              {{ item.idExEncabezado }}
            </td>
            <td>{{ item.idExProducto }}</td>
            <td>{{ item.descripcion }}</td>
            <td>{{ item.cantidadDetalle }}</td>
            <td>{{ item.cantidadPicking }}</td>
            <td>{{ item.fechaPedido | date: "yyyy-MM-dd" }}</td>
            <td>{{ item.fechaPicking | date: "yyyy-MM-dd" }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- <div class="col s12 m4 l4">
      <mat-card class="example-card">
        <mat-card-header>
          <mat-card-title>Ubicación</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div #mapContainer id="map"></div>
        </mat-card-content>
      </mat-card>
    </div> -->
  </div>
</mat-dialog-content>

<mat-dialog-actions align="start">
  <!-- <div>
    <div style="float: left;">
      <p style="color: green; font-weight: bold;">TOTAL: </p>
    </div>
    <div style="float: left; margin-left: 20px;">
      <p style="color: gray; font-weight: bold;">{{totalPedido | currency: "$":"symbol":"1.0-0" }}</p>
    </div>
  </div> -->
  <div class="row center">

  <button
    mat-raised-button
    color="primary"
    [mat-dialog-close]="dataModified"
    cdkFocusInitial
  >Cerrar</button>
</div>
</mat-dialog-actions>
